export const IssueKeys = [
  "wrong_item_received",
  "item_damaged",
  "not_found",
  "partial_not_found",
  "ofd_db_lost_damage",
];

export const IssuesToReturn = [
  "wrong_item_received",
  "item_damaged",
  "partial_not_found",
];

export const meta = {
  wrong_item_received: "गलत आइटम",
  item_damaged: "डैमेज/ख़राब",
  not_found: "नहीं मिला",
  partial_not_found: "कुछ आइटम \n नहीं मिले",
  ofd_db_lost_damage: "लॉस्ट",
  issue_header: "कृप्या अपनी समस्या बताएं",
  issue_label: "समस्या है ?",
  all_found: "सब मिल गया",
  add_to_bag_cta: "बैग में डाल लिया ",
  crate_item_label: "क्रेट आइटम्स",
  sku_wise_order_items_label: "Open आइटम्स",
  top_sku_items_label: "Inventory Items",
  shipment_label: "पैकेट्स",
  shipment_id_label: "पैकेट :",
  cod_label: "कैश पेमेंट",
  online_label: "ऑनलाइन",
  cod_refund_label: "कस्टमर से कैश लेना है",
  online_refund_label: "कस्टमर को रिफंड जायेगा ",
  raised_issue_label: "समस्या दर्ज की",
  payment_mode: "पेमेंट मोड",
  delivery_code: "डिलीवरी कोड",
  delivery_code_not_created: "अभी डिलीवरी कोड जेनेरेट नहीं हुआ है!",
  delivery_code_created:
    "कृप्या डिलीवरी कोड देने से पहले ऑर्डर डिलीवरी और रिटर्न डिटेल्स  ठीक से देख लें!",
  return_already_raised: "दर्ज़ समस्याओं पर पहले से रिटर्न लगा हुआ है",
  change_samasya: "दर्ज समस्या में बदलाव करना चाहते हैं?",
  change: "बदलाव करें",
  submit: "सबमिट करे",
  lost_damage: "लॉस्ट/डैमेज",
  other_crate_label: "दूसरे क्रैट आइटम्स",
  packed_orders: "पैक्ड ऑर्डर्स",
};
